<script>
export default {
  name: "SNCRProgressBar",
  props: {
    labelHeader: {
      required: true,
      type: String
    },
    labelFooter: {
      required: false,
      type: String
    },
    valueUsado: {
      required: true,
      type: Number
    },
    valueLimite: {
      required: true,
      type: Number
    },
  },
  computed: {
    progressoClass() {
      if (this.progresso >= 90) return 'bg-danger';
      if (this.progresso >= 60) return 'bg-warning';
      return 'bg-info';
    },
    progresso() {
      if (!this.valueLimite || this.valueLimite <= 0) return 0;

      const porcentagem = Math.round((this.valueUsado / this.valueLimite) * 100);
      return Math.min(100, Math.max(0, porcentagem));
    },
    numeracoesDisponiveis() {
      return Math.max(0, (this.valueLimite || 0) - (this.valueUsado || 0));
    },
    labelFooterPlural() {
      if (!this.labelFooter) return '';

      const qtd = this.numeracoesDisponiveis;

      if (qtd === 0) return `Nenhuma numeração disponível ${this.labelFooter}`;
      if (qtd === 1) return `1 numeração disponível ${this.labelFooter}`;
      return `${qtd} numerações disponíveis ${this.labelFooter}`;
    }
  }
}
</script>

<template>
  <div class="rounded py-1 mb-1">
    <div class="d-flex justify-content-between align-items-baseline small mb-1">
      <span class="text-dark" style="font-weight: 500;">{{ labelHeader }}</span>
      <span>
        <strong>{{ valueUsado }}</strong>
        <span class="text-muted"> de {{ valueLimite }}</span>
      </span>
    </div>
    <div class="progress" style="height: 6px; border-radius: 4px;">
      <div
        class="progress-bar"
        :class="progressoClass"
        role="progressbar"
        :style="{ width: progresso + '%' }"
        :aria-valuenow="valueUsado"
        aria-valuemin="0"
        :aria-valuemax="valueLimite"
      ></div>
    </div>
    <p v-if="labelFooter" class="small text-muted mb-0 mt-1">
      {{ labelFooterPlural }}
    </p>
  </div>
</template>

<style scoped>

</style>